import React, { useState } from "react";
import cl from "classnames";

export default function Solution({ tab }) {

  return (
    <div
      className={cl("lesson_tab p-3 w-100 h-100", {
        active: tab === "solution",
      })}
      id="solution"
      role="tabpanel"
      aria-labelledby="solution-tab"
    >
      <div className="lesson_timer h-100">
        <p className="lead">Решение учителя откроется через:</p>
        <div className="timer-primary display-4">20 : 00</div>
      </div>
    </div>
  );
}
